import React from 'react'

import colors from 'src/styles/theme/colors'

const variantComponentMapping = {
  h1: { element: 'h1', className: 'typography-rebrand-h1' },
  h2: { element: 'h2', className: 'typography-rebrand-h2' },
  h3: { element: 'h3', className: 'typography-rebrand-h3' },
  h4: { element: 'h4', className: 'typography-rebrand-h4' },
  h5: { element: 'h5', className: 'typography-rebrand-h5' },
  eyebrow: { element: 'span', className: 'typography-rebrand-eyebrow' },
  introduction: {
    element: 'div',
    className: 'typography-rebrand-introduction'
  },
  body: { element: 'div', className: 'typography-rebrand-body' },
  paragraph: { element: 'div', className: 'typography-rebrand-paragraph' },
  paragraphSmall: {
    element: 'div',
    className: 'typography-rebrand-paragraph-small'
  },
  caption: { element: 'span', className: 'typography-rebrand-caption' }
}

export type TypographyRebrandProps = {
  variant: keyof typeof variantComponentMapping
  tight?: boolean
  children: React.ReactNode
  color?: keyof typeof colors
  // Override the rendered element while keeping the variant's visual styling —
  // e.g. render h1-sized text as an <h2> to avoid multiple <h1>s on a page.
  as?: React.ElementType
}

const TypographyRebrand = ({
  children,
  variant = 'body',
  tight,
  color,
  as
}: TypographyRebrandProps) => {
  const { className, element } = variantComponentMapping[variant]
  const finalClassName = `${className} ${tight ? 'tight' : ''}`
  return React.createElement(
    as || element,
    {
      ...(color && { style: { color: colors[color] } }),
      className: finalClassName
    },
    children
  )
}

export default TypographyRebrand
